export const config = {
    name: 'Faq SB',
    inputs: [],
};
